import * as React from 'react';
import { LogoWithIcon } from 'src/Components/Landing/LogoWithIcon';
import { getSidebarService } from 'src/utils/injectionHelpers';
import { SidebarItem } from 'src/Components/Header/SidebarItem';
import { RouterLinks } from 'src/routing/routerLinks';
import { useAsmRouter } from 'src/utils/hooks';
import { CreateNewJobConfirmationModal } from 'src/Components/HomePage/CreateNewJobConfirmationModal/CreateNewJobConfirmationModal';
import { SidebarSearchButton } from '../SidebarSearchButton';
import { LogoIcon } from 'src/Components/Landing/LogoIcon';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from 'src/shadcn/components/ui/sidebar';
import { DashboardSidebarFooter } from './DashboardSidebarFooter';
import { PanelLeftIcon } from 'lucide-react';

export interface IDashboardPageSidebarProps {
  currentRoute: RouterLinks;
}

export const DashboardPageSidebar: React.FunctionComponent<
  IDashboardPageSidebarProps
> = props => {
  const sidebarService = getSidebarService();
  const router = useAsmRouter();
  const sideBarItems = sidebarService.getItems().map(itemGroup => {
    return {
      ...itemGroup,
      items: itemGroup.items.map(item => ({
        ...item,
        isCurrentRoute: item.link === props.currentRoute,
      })),
    };
  });
  const sidebar = useSidebar('main');

  return (
    <>
      <Sidebar collapsible='offcanvas' variant='sidebar' sidebarId='main'>
        <SidebarHeader>
          <SidebarGroup>
            <div className='flex items-center justify-center px-2'>
              <LogoWithIcon
                className='h-[25px] hover:opacity-70 group-data-[collapsible=icon]:hidden'
                onClick={() => router.pushFlat(RouterLinks.Home)}
              />
              <LogoIcon className='hidden h-[25px] hover:opacity-70 group-data-[collapsible=icon]:block' />
            </div>
          </SidebarGroup>
          <SidebarMenu>
            <SidebarMenuItem className='flex items-center gap-2'>
              <CreateNewJobConfirmationModal
                id={'create-modal-sidebar'}
                isMinimized={false}
              />
              {sidebar.open && <SidebarSearchButton />}
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarHeader>

        <SidebarContent>
          <SidebarGroup>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  sidebarId='main'
                  onClick={() => sidebar.toggleSidebar()}
                >
                  <PanelLeftIcon className='h-4 w-4' /> Collapse
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroup>
          {sideBarItems.map(itemGroup => {
            return (
              <SidebarGroup>
                {itemGroup.groupName && (
                  <SidebarGroupLabel>{itemGroup.groupName}</SidebarGroupLabel>
                )}

                <SidebarGroupContent>
                  <SidebarMenu>
                    {itemGroup.items.map(itemKey => {
                      return (
                        <SidebarItem
                          key={itemKey.link}
                          item={itemKey}
                          isCurrentRoute={itemKey.link === props.currentRoute}
                        />
                      );
                    })}
                  </SidebarMenu>
                </SidebarGroupContent>
              </SidebarGroup>
            );
          })}
        </SidebarContent>

        <DashboardSidebarFooter />
        {/* <div className='flex w-full flex-col items-center gap-3'>
            <div className='group-data-[collapsible=icon]:hidden'>
              <div className='mb-3 flex flex-col text-center'>
                <div className='text-sm font-medium'>
                  {authContext.user?.user.companyName}
                </div>
                {authContext.user?.employee?.firstName && (
                  <div className='text-sm text-muted-foreground'>
                    {[
                      authContext.user?.employee?.firstName,
                      authContext.user?.employee?.lastName,
                    ]
                      .filter(notEmpty)
                      .join(' ')}
                  </div>
                )}
              </div>
              {sidebarService.getEnabledFeatures().shiftInSidebar && (
                <div className='mb-3 w-full'>
                  <DashboardSidebarShift />
                </div>
              )}
            </div>
            <div className='flex w-full items-center justify-between group-data-[collapsible=icon]:justify-center'>
              <div className='group-data-[collapsible=icon]:hidden'>
                <SiderBarSettingsMenu isMinimized={false} />
              </div>
              <SidebarTrigger className='group-data-[collapsible=icon]:mx-auto' />
            </div>
          </div> */}
        {/* <SidebarRail /> */}
      </Sidebar>
    </>
  );
};
